import { html } from "lit";
import { queryAssignedElements } from "@lit/reactive-element/decorators/query-assigned-elements.js";
import { DsfRadio } from "../Radio/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { prop } from "../../../decorators/prop/index.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { preventDefault } from "../../../decorators/preventDefault.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const navigationKeys = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"];
let DsfRadioGroup = class extends BaseComponent {
  syncSelectedState() {
    this.radioElements.forEach((el) => el.setChecked(el.value === this.value));
  }
  handleSlotInput() {
  }
  handleSlotUpdate() {
    this.syncSelectedState();
  }
  handleSlotClick(ev) {
    if (!ev.target || !(ev.target instanceof DsfRadio)) {
      return;
    }
    const radio = ev.target;
    if (radio.disabled) {
      return;
    }
    if (radio.value !== this.value) {
      this.value = radio.value;
      this.emit({ name: "input", payload: this.value });
      this.emit({ name: "change", payload: this.value });
    }
  }
  handleKeyDown(ev) {
    const key = ev.key;
    if (!navigationKeys.includes(key)) {
      return;
    }
    ev.preventDefault();
    const enabledRadios = [...this.radioElements].filter((r) => !r.disabled);
    if (!enabledRadios) {
      return;
    }
    const focusedRadio = enabledRadios.find((r) => r === document.activeElement) || enabledRadios[0];
    const indexIncrement = key === "ArrowDown" || key === "ArrowRight" ? 1 : -1;
    let nextIndex = enabledRadios.indexOf(focusedRadio) + indexIncrement;
    if (nextIndex < 0) {
      nextIndex = enabledRadios.length - 1;
    }
    if (nextIndex > enabledRadios.length - 1) {
      nextIndex = 0;
    }
    enabledRadios[nextIndex].focus();
  }
  update(changedProps) {
    if (changedProps.has("value")) {
      this.syncSelectedState();
    }
    super.update(changedProps);
  }
  render() {
    return html`
      <slot
        class="flex flex-auto flex-col gap-8"
        @slotchange=${this.handleSlotUpdate}
        @click=${this.handleSlotClick}
        @input=${this.handleSlotInput}
        @keydown=${this.handleKeyDown}
      >
      </slot>
    `;
  }
};
__decorateClass([
  prop({ type: String })
], DsfRadioGroup.prototype, "value", 2);
__decorateClass([
  queryAssignedElements({ selector: "dsf-radio" })
], DsfRadioGroup.prototype, "radioElements", 2);
__decorateClass([
  preventDefault
], DsfRadioGroup.prototype, "handleSlotInput", 1);
DsfRadioGroup = __decorateClass([
  defineElement("dsf-radio-group")
], DsfRadioGroup);
export {
  DsfRadioGroup
};
